// Carrinho vazio do mini-cart: mensagem, atalhos para colecoes e o banner principal da home.
// Para trocar os botoes, edite a lista LINKS abaixo.
(function () {
  var items = document.getElementById('miniCartItems');
  if (!items || !window.MutationObserver) return;

  var LINKS = [
    { label: 'Mais vendidos', url: '/collections/mais-vendidos' },
    { label: 'Lançamentos', url: '/collections/lancamentos' }
  ];
  var BANNER_SELECTOR = '.full-banner-carrossel:not(.product-gallery-carrossel)';
  var CACHE_KEY = 'miniCartEmptyBanner';
  var bannerPromise = null;

  var style = document.createElement('style');
  style.textContent =
    '.mini-cart__empty--tips{justify-content:flex-start;padding:36px 0 0;width:100%}' +
    '.mini-cart__empty--tips .mini-cart__empty-text{font-size:17px;line-height:1.45;margin:0 0 24px;max-width:300px}' +
    '.mini-cart__empty-links{display:flex;flex-direction:column;gap:10px;width:100%;max-width:280px}' +
    '.mini-cart__empty-link{display:block;padding:16px 12px;border:1px solid #1d1d1b;border-radius:4px;background:#fff;color:#1d1d1b;font-size:13px;text-align:center;text-decoration:none;transition:background .2s,color .2s}' +
    '.mini-cart__empty-link:hover{background:#1d1d1b;color:#fff}' +
    '.mini-cart__empty-banner{display:block;align-self:stretch;margin-top:32px}' +
    '.mini-cart__empty-banner[hidden]{display:none}' +
    '.mini-cart__empty-banner img{display:block;width:100%;height:auto}';
  document.head.appendChild(style);

  // Le o primeiro slide do banner principal da home (versao mobile, que e vertical)
  function readBanner(doc) {
    var carousel = doc.querySelector(BANNER_SELECTOR);
    if (!carousel) return null;
    var slide = carousel.querySelector('[data-swiper-slide-index="0"]:not(.swiper-slide-duplicate)') ||
      carousel.querySelector('.swiper-slide:not(.swiper-slide-duplicate)');
    if (!slide) return null;
    var link = slide.querySelector('a[href]');
    var source = slide.querySelector('source[media*="max-width"]') || slide.querySelector('source');
    var img = slide.querySelector('img');
    var srcset = source ? source.getAttribute('srcset') : (img ? img.getAttribute('srcset') : '');
    var src = img ? img.getAttribute('src') : '';
    if (!srcset && !src) return null;
    return {
      href: link ? link.getAttribute('href') : '',
      srcset: (srcset || '').replace(/\s+/g, ' ').trim(),
      src: src || '',
      alt: img ? (img.getAttribute('alt') || '') : ''
    };
  }

  function getBanner() {
    if (bannerPromise) return bannerPromise;
    try {
      var cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) return (bannerPromise = Promise.resolve(JSON.parse(cached)));
    } catch (err) {}

    var local = readBanner(document);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    bannerPromise = (local ? Promise.resolve(local) : fetch(root)
      .then(function (r) { return r.text(); })
      .then(function (html) { return readBanner(new DOMParser().parseFromString(html, 'text/html')); }))
      .then(function (banner) {
        try { if (banner) sessionStorage.setItem(CACHE_KEY, JSON.stringify(banner)); } catch (err) {}
        return banner;
      })
      .catch(function () { return null; });
    return bannerPromise;
  }

  // O banner encosta nas bordas do mini-cart: compensa o padding da lista,
  // que muda entre desktop e mobile (no mobile o tema o aplica inline)
  function bleed() {
    var bannerLink = items.querySelector('.mini-cart__empty-banner');
    if (!bannerLink) return;
    var cs = getComputedStyle(items);
    bannerLink.style.marginLeft = '-' + cs.paddingLeft;
    bannerLink.style.marginRight = '-' + cs.paddingRight;
    bannerLink.style.marginBottom = '-' + cs.paddingBottom;
  }

  function render(empty) {
    if (empty.classList.contains('mini-cart__empty--tips')) return;
    empty.classList.add('mini-cart__empty--tips');
    empty.textContent = '';

    var text = document.createElement('p');
    text.className = 'mini-cart__empty-text';
    text.appendChild(document.createTextNode('Seu carrinho está vazio.'));
    text.appendChild(document.createElement('br'));
    text.appendChild(document.createTextNode('Precisa de uma dica para começar?'));
    empty.appendChild(text);

    var links = document.createElement('div');
    links.className = 'mini-cart__empty-links';
    LINKS.forEach(function (item) {
      var a = document.createElement('a');
      a.className = 'mini-cart__empty-link';
      a.href = item.url;
      a.textContent = item.label;
      links.appendChild(a);
    });
    empty.appendChild(links);

    var bannerLink = document.createElement('a');
    bannerLink.className = 'mini-cart__empty-banner';
    bannerLink.hidden = true;
    empty.appendChild(bannerLink);

    getBanner().then(function (banner) {
      if (!banner) return;
      var img = document.createElement('img');
      if (banner.srcset) {
        img.srcset = banner.srcset;
        img.sizes = '(max-width: 480px) 100vw, 420px';
      }
      if (banner.src) img.src = banner.src;
      img.alt = banner.alt;
      img.loading = 'lazy';
      if (banner.href) bannerLink.href = banner.href;
      bannerLink.appendChild(img);
      bannerLink.hidden = false;
      bleed();
    });
  }

  function check() {
    var empty = items.querySelector('.mini-cart__empty');
    if (!empty) return;
    render(empty);
    bleed();
  }

  new MutationObserver(check).observe(items, { childList: true });
  window.addEventListener('resize', bleed);
  check();
})();
